
import filters from "@/filters";
import { Component, Vue, Watch } from "vue-property-decorator";
import AppLayout from "@/layouts/AppLayout.vue";
import CourseItem from "@/components/CourseItem.vue";
import CourseAccordion from "@/components/CourseAccordion.vue";
import { Action } from "vuex-class";
import { CourseLevelEnum, EnumHelper, PaymentTypeEnum } from "@/constants/enum.constant";
import { AxiosResponse } from "axios";
import _ from "lodash";
import { random } from "@/functions/global.function";
import { getToken } from "@/functions/token.function";
import ContentFooter from "@/components/ContentFooter.vue";
import toast from "@/functions/toast.function";

@Component({
  components: {
    CourseAccordion,
    CourseItem,
    AppLayout,
    ContentFooter,
  },
  filters,
})
export default class CourseDetail extends Vue {
  @Action("getCourseDetail", { namespace: "course" })
  private getCourseDetail: any;
  @Action("getCourseRating", { namespace: "course" })
  private getCourseRating: any;
  @Action("buy", { namespace: "payment" })
  private buys: any;

  private course: any = null;
  private levels = EnumHelper(CourseLevelEnum);
  private contentsHash = random();
  private ratings = [];
  private ratingTotal = 0;
  private phone = "+62";
  private paymentType = 0;
  private courseCarousel = {
    0: {
      items: 1,
    },
    768: {
      items: 2,
    },
    1200: {
      items: 3,
    },
  };

  private get rating() {
    return {
      value: parseFloat(this.course?.ratings_avg_rating).toFixed(1),
      floor: Math.floor(parseFloat(this.course?.ratings_avg_rating)),
      total: this.course?.ratings_count,
    };
  }
  private get level() {
    return this.levels.find((value) => value.id === this.course?.level)?.name;
  }
  private get feedbacks() {
    return _.orderBy(this.course?.ratings, "value", "desc");
  }

  private get ratingPagination() {
    return {
      perPage: 8,
      currentPage: 1,
      rows: this.ratingTotal,
      items: this.ratings,
    };
  }

  @Watch("$route.params.slug")
  private onSlugChange() {
    this.fetchData();
  }

  private created() {
    this.fetchData();
  }

  private fetchData() {
    this.course = null;
    this.getCourseDetail({
      params: {
        slug: this.$route.params.slug,
      },
      success: (response: AxiosResponse) => {
        let data = response.data.data;
        data.learns = this.parseJson(data.learns);
        data.materials = this.parseJson(data.materials);
        data.requirements = this.parseJson(data.requirements);
        data.audiences = this.parseJson(data.audiences);

        this.course = data;

        this.getRatingData();
      },
    });
  }

  private getRatingData(page: number = 1) {
    this.getCourseRating({
      params: {
        id: this.course?.id,
        page: page || 1,
      },
      success: (response: AxiosResponse) => {
        this.ratings = response.data.data.data;
        this.ratingTotal = response.data.data.total;
      },
    });
  }

  private buy() {
    const token = getToken();
    if (getToken()) {
      if (this.course?.id) {
        this.$router.push({
          name: 'checkout',
          params: {
            course_id: this.course?.id,
            price: this.course?.price,
            offer_price: this.course?.offer_price,
            name: this.course?.name,
          },
          query: {
            token: token || '',
          },
        });
      }
    } else {
      this.$router.push({
        name: 'login',
      });
    }
  }


  private goToMyCourses() {
    const token = getToken();
    const paymentTypeValue = PaymentTypeEnum.FREE;

    if (token) {
      if (this.course?.id) {
        this.buys({
          params: {
            course_id: this.course.id,
            payment_type: paymentTypeValue,
            phone: this.phone,
            // partner_code_id: null, 
          },
          success: (response: AxiosResponse) => {

            try {
              const urls = JSON.parse(response.data.data.url);
              const redirect =
                urls?.desktop_web_checkout_url || urls?.mobile_web_checkout_url;
              if (redirect) {
                switch (this.paymentType) {
                  case PaymentTypeEnum.DANA:
                    window.open(redirect, "_blank");
                    break;
                  default:
                    break;
                }
              }
            } catch (e) {
              console.error("Failed to redirect.", e);
            }

            this.$router.push({
              name: "my-courses",
            });
          },
        });
      }
    } else {
      this.$router.push({
        name: "login",
      });
    }
  }

  private goToMyCourses2() {
    this.$router.push({
      name: "my-courses",
    });
  }


  private parseJson(data) {
    try {
      return JSON.parse(data);
    } catch (e) {
      return [];
    }
  }

  private detail() {
    this.$router.push({
      name: "my-course-detail",
      params: {
        slug: this.course?.slug,
      },
    });
  }

  public handleShare(platform: string) {
    const url = window.location.href;
    let shareUrl = '';

    switch (platform) {
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        window.open(shareUrl, '_blank');
        break;
      case 'whatsapp':
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`;
        window.open(shareUrl, '_blank');
        break;
      case 'x':
        shareUrl = `https://x.com/intent/tweet?url=${encodeURIComponent(url)}`;
        window.open(shareUrl, '_blank');
        break;
      case 'telegram':
        shareUrl = `https://t.me/share/url?url=${encodeURIComponent(url)}`;
        window.open(shareUrl, '_blank');
        break;
      case 'copy':
        navigator.clipboard.writeText(url).then(() => {
          toast.success(this.$t("course_detail_link_copied") as string);
        });
        return;
      case 'share':
        if (navigator.share) {
          navigator.share({
            title: document.title,
            url: url,
          }).catch((error) => console.log('Error sharing', error));
        } else {
          toast.error(this.$t("course_detail_share_not_supported") as string);
        }
        return;
      default:
        return;
    }
  }
}
